import { render, staticRenderFns } from "./CategoriesBar.vue?vue&type=template&id=b2ef0118&scoped=true&lang=pug"
import script from "./CategoriesBar.vue?vue&type=script&lang=js"
export * from "./CategoriesBar.vue?vue&type=script&lang=js"
import style0 from "./CategoriesBar.vue?vue&type=style&index=0&id=b2ef0118&prod&lang=scss"
import style1 from "./CategoriesBar.vue?vue&type=style&index=1&id=b2ef0118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ef0118",
  null
  
)

export default component.exports